import { createReducer } from '@reduxjs/toolkit';

import * as welcomeMessageActions from './welcomeMessageActions.js';

const initialState = {
  requesting: false,
  error: null,

  id: 0,
  uid: 0,
  type: 'welcome',
  isActive: false,
  isAdded: false,

  message: '',
  frequency: 1,
  delay: 0,

  sectionIsBackground: false,
  sectionTextColor: '#000000',
  sectionShadow: 'soft',
  sectionShadowColor: '#000',
  sectionShadowBorderColor: '#ECECF0',
  sectionBorderColor: '#ECECF0',
  sectionShape: 'round',
  sectionOpacity: 0,
  sectionBackgroundColor: '#ffffff',
  sectionIsFullWidth: false,
  sectionPadding: 20,
  sectionMargin: 12,
  sectionBackgroundType: 1,
  sectionBackgroundImage: '',
  sectionGradientColor1: '#B3F7EF',
  sectionGradientColor2: '#F7D6E0',
  sectionGradientDirection: 0,
  sectionGradientOffset: 0,
  sectionBorder: 'none',
};

const welcomeMessage = createReducer(initialState, (builder) => {
  builder
    .addCase(welcomeMessageActions.welcomeMessageUpdateId, (state, { payload: id }) => ({ ...state, id }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateIsAdded, (state, { payload: isAdded }) => ({ ...state, isAdded }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateIsActive, (state, { payload: isActive }) => ({ ...state, isActive }))

    .addCase(welcomeMessageActions.welcomeMessageStore, (state, { payload }) => {
      const { uid, isAdded, isActive, data } = payload;

      const section = data ?? {};

      const {
        id,

        message,
        frequency,
        delay,

        sectionBackgroundColor,
        sectionTextColor,
        sectionOpacity,
        sectionIsFullWidth,
        sectionShadow,
        sectionShadowColor,
        sectionShadowBorderColor,
        sectionPadding,
        sectionMargin,
        isSectionBackground,
        sectionBackgroundType,
        sectionBackgroundImage,
        sectionGradientColor1,
        sectionGradientColor2,
        sectionGradientDirection,
        sectionGradientOffset,
        sectionShape,
        sectionBorderColor,
        sectionBorder,
      } = section;

      return {
        ...state,

        error: null,
        requesting: false,

        id: id ?? 0,
        uid: uid ?? 0,
        isActive: isActive,
        isAdded: isAdded,

        message: message ?? '',
        frequency: frequency ?? 1,
        delay: delay ?? 0,

        sectionMargin: sectionMargin,
        sectionBackgroundColor: sectionBackgroundColor ?? '#ffffff',
        sectionTextColor: sectionTextColor ?? '#000000',
        sectionOpacity: sectionOpacity ?? 0,
        sectionIsFullWidth: sectionIsFullWidth ?? false,
        sectionShadow: sectionShadow ?? 'none',
        sectionShadowColor: sectionShadowColor ?? '#000',
        sectionPadding: sectionPadding,
        sectionIsBackground: isSectionBackground ?? false,
        sectionBackgroundType: sectionBackgroundType ?? 1,
        sectionBackgroundImage: sectionBackgroundImage ?? '',
        sectionGradientColor1: sectionGradientColor1 ?? '#B3F7EF',
        sectionGradientColor2: sectionGradientColor2 ?? '#F7D6E0',
        sectionGradientDirection: sectionGradientDirection ?? 0,
        sectionGradientOffset: sectionGradientOffset ?? 0,
        sectionShadowBorderColor: sectionShadowBorderColor ?? '#000',
        sectionBorderColor: sectionBorderColor ?? '#000',
        sectionShape: sectionShape ?? 'round',
        sectionBorder: sectionBorder ?? 'none',
      };
    })

    .addCase(welcomeMessageActions.welcomeMessageClear, () => ({ ...initialState }))

    .addCase(welcomeMessageActions.welcomeMessageUpdateRequest, (state) => ({ ...state, requesting: true, error: null }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateError, (state, { payload }) => ({ ...state, error: payload, requesting: false }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateStore, (state) => ({ ...state, error: false, requesting: false }))

    .addCase(welcomeMessageActions.welcomeMessageUpdateMessage, (state, { payload: message }) => ({ ...state, message }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateFrequency, (state, { payload: frequency }) => ({ ...state, frequency }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateDelay, (state, { payload: delay }) => ({ ...state, delay }))

    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionIsBackground, (state, { payload: sectionIsBackground }) => ({ ...state, sectionIsBackground }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionTextColor, (state, { payload: sectionTextColor }) => ({ ...state, sectionTextColor }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionBackgroundColor, (state, { payload: sectionBackgroundColor }) => ({ ...state, sectionBackgroundColor }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionOpacity, (state, { payload: sectionOpacity }) => ({ ...state, sectionOpacity }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionIsFullWidth, (state, { payload: sectionIsFullWidth }) => ({ ...state, sectionIsFullWidth }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionShadow, (state, { payload: sectionShadow }) => ({ ...state, sectionShadow }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionShadowColor, (state, { payload: sectionShadowColor }) => ({ ...state, sectionShadowColor }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionPadding, (state, { payload: sectionPadding }) => ({ ...state, sectionPadding }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionMargin, (state, { payload: sectionMargin }) => ({ ...state, sectionMargin }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionBackgroundType, (state, { payload: sectionBackgroundType }) => ({ ...state, sectionBackgroundType }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionBackgroundImage, (state, { payload: sectionBackgroundImage }) => ({ ...state, sectionBackgroundImage }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionGradientColor1, (state, { payload: sectionGradientColor1 }) => ({ ...state, sectionGradientColor1 }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionGradientColor2, (state, { payload: sectionGradientColor2 }) => ({ ...state, sectionGradientColor2 }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionGradientDirection, (state, { payload: sectionGradientDirection }) => ({ ...state, sectionGradientDirection }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionGradientOffset, (state, { payload: sectionGradientOffset }) => ({ ...state, sectionGradientOffset }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionShadowBorderColor, (state, { payload: sectionShadowBorderColor }) => ({ ...state, sectionShadowBorderColor }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionBorderColor, (state, { payload: sectionBorderColor }) => ({ ...state, sectionBorderColor }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionShape, (state, { payload: sectionShape }) => ({ ...state, sectionShape }))
    .addCase(welcomeMessageActions.welcomeMessageUpdateSectionBorder, (state, { payload: sectionBorder }) => ({ ...state, sectionBorder }));
});

export default welcomeMessage;
